import * as React from 'react';
import Loadable from 'react-loadable';

import { lazyInject } from 'src/ioc';
import { LoadingStore } from '../stores/loading.store';

export class BusyLoader extends React.PureComponent<Loadable.LoadingComponentProps> {
    @lazyInject(LoadingStore) private loading!: LoadingStore;

    isError = false;

    constructor(props: Loadable.LoadingComponentProps) {
        super(props);
        this.loading.busy(true);
    }

    componentWillUnmount() {
        if (!this.isError) {
            this.loading.busy(false);
        }
    }

    componentWillReceiveProps(nextProps: Loadable.LoadingComponentProps) {
        if (nextProps.error) {
            this.isError = true;
        }
    }

    render() {
        if (this.props.error) {
            return <div>Error loading module: {this.props.error.toString()}</div>;
        }
        return null;
    }
}
